import React, { useEffect, useState } from 'react';
import ReportFilterForm from './components/ReportFilterForm';
import ReportTable from './components/tables/ReportTable';
import { CandidateTestDetails, ITestDetailReport } from './report-models/report.interface';

type IFilterTableProps ={
  setXport: React.Dispatch<React.SetStateAction<boolean>>
  testDetailReport?: ITestDetailReport;
 }

const FilterTable = ({testDetailReport,setXport}: IFilterTableProps) => {
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [data, setData] = useState<CandidateTestDetails[]>() ;
  const [searchText, setSearchText] = useState<string>('');

  const handleSearch = (text: string) => {
    setSearchText(text);

    // Filter the data based on the search input
    const filteredData = testDetailReport?.details?.filter((item) =>
      Object.values(item).some((value) =>
        String(value).toLowerCase().includes(text.toLowerCase())
      )
    );

    setData(filteredData);
  };
  
  useEffect(() => {
    setData(testDetailReport?.details)
  }, [testDetailReport])
  

  return (
    <div>
      <ReportFilterForm handleSearch={handleSearch} searchText={searchText}  selectedRowKeys={selectedRowKeys} setXport={setXport} />
      {testDetailReport && (
        <ReportTable
          tableData={data? data: []}
          selectedRowKeys={selectedRowKeys}
          setSelectedRowKeys={setSelectedRowKeys}
        />
      )}
    </div>
  );
};

export default FilterTable;
